class PageOptions {
  constructor(
    page = 1,
    take = null,
    expand = null,
    search = null,
    field = "all",
    sort = null,

  ) {
    this.page = page;
    this["per-page"] = take;
    this.expand = expand;
    this[`search[${field}]`] = search;
    this.sort = sort
  }
}

export default PageOptions;
